import { setTaskUnassigned } from '@dispatch/shared/services';
import { useCurrentUser } from '@dispatch/web/auth';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

export function useSetTaskUnassigned(
  onSuccess: () => void,
  onError: (message: string) => void
) {
  const queryClient = useQueryClient();
  const { userEmail } = useCurrentUser();

  return useMutation(
    async ({ taskId }: { taskId: string }) =>
      setTaskUnassigned(taskId, userEmail || ''),
    {
      onSuccess,
      onError: (error: AxiosError) => {
        onError(
          error.message || 'An error occurred while unassigning the task'
        );
      },
      onSettled: () => {
        // Data that needs to be invalidated when task updates
        queryClient.invalidateQueries(['schedule-data']);
        queryClient.invalidateQueries(['schedule-data-infinite']);
        queryClient.invalidateQueries(['summaries']);
        queryClient.invalidateQueries(['task']);
        queryClient.invalidateQueries(['resource-tasks-assigned']);
        queryClient.invalidateQueries(['resource-tasks-unassigned']);
      },
    }
  );
}
